(function () {
  'use strict';

  var API_KEY  = 'AIzaSyC2RMBB-dIlFzVWH2u98pgtox1YFPyQrwQ';
  var MODEL    = 'gemini-3.1-flash-image-preview';
  var ENDPOINT = 'https://generativelanguage.googleapis.com/v1beta/models/' + MODEL + ':generateContent?key=' + API_KEY;
  var PROMPT   = 'Du bekommst zwei Bilder: Das erste ist ein Zimmerfoto, das zweite ist ein Wandbild / Kunstwerk. Platziere das Wandbild aus dem zweiten Bild natürlich und realistisch an einer geeigneten Wand im Zimmerfoto. Achte auf Beleuchtung, Schatten, Perspektive und realistische Proportionen, sodass es wirkt als wäre das Bild immer dort gewesen. Gib ausschließlich das fertige Zimmerbild zurück.';

  /* ─── Rate limiting (localStorage, 5x per 24h per Browser) ──── */
  var RL_KEY  = 'rv_rl';
  var RL_MAX  = 5;
  var RL_TTL  = 24 * 60 * 60 * 1000;

  function rlCheck() {
    try {
      var raw  = localStorage.getItem(RL_KEY);
      var data = raw ? JSON.parse(raw) : { ts: Date.now(), n: 0 };
      if (Date.now() - data.ts > RL_TTL) data = { ts: Date.now(), n: 0 };
      if (data.n >= RL_MAX) return false;
      data.n++;
      localStorage.setItem(RL_KEY, JSON.stringify(data));
      return true;
    } catch (e) { return true; }
  }

  function rlRemaining() {
    try {
      var raw  = localStorage.getItem(RL_KEY);
      var data = raw ? JSON.parse(raw) : { ts: Date.now(), n: 0 };
      if (Date.now() - data.ts > RL_TTL) return RL_MAX;
      return Math.max(0, RL_MAX - data.n);
    } catch (e) { return RL_MAX; }
  }

  /* ─── Loading messages ──────────────────────────────────────── */
  var LOAD_MSGS = [
    'Zimmer wird analysiert …',
    'Wand wird ausgemessen …',
    'Kunstwerk wird angepasst …',
    'Licht und Schatten werden angepasst …',
    'Letzter Feinschliff …',
    'Das Bild ist gleich fertig …',
  ];

  /* ─── Inject CSS once ───────────────────────────────────────── */
  function injectCSS() {
    if (document.getElementById('rv-css')) return;
    var s = document.createElement('style');
    s.id = 'rv-css';
    s.textContent = [
      '.rv-overlay{display:none;position:fixed;inset:0;z-index:2147483647;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.55);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);}',
      '.rv-overlay.rv--open{display:flex;animation:rv-fade .2s ease both;}',
      '.rv-card{position:relative;width:100%;max-width:540px;max-height:92dvh;overflow-y:auto;background:#fff;border-radius:18px;box-shadow:0 30px 90px rgba(0,0,0,.28);padding:24px;animation:rv-up .28s cubic-bezier(.34,1.4,.64,1) both;scrollbar-width:thin;}',
      '.rv-bar{display:flex;align-items:center;justify-content:space-between;margin-bottom:20px;}',
      '.rv-close{display:flex;align-items:center;justify-content:center;width:32px;height:32px;background:rgba(0,0,0,.07);border:none;border-radius:50%;cursor:pointer;color:#000;transition:background .15s;flex-shrink:0;}',
      '.rv-close:hover{background:rgba(0,0,0,.14);}',
      '.rv-dots{display:flex;gap:6px;}',
      '.rv-dot{width:7px;height:7px;border-radius:50%;background:rgba(0,0,0,.15);transition:background .2s,transform .2s;}',
      '.rv-dot.rv-dot--now{background:#000;transform:scale(1.3);}',
      '.rv-dot.rv-dot--done{background:rgba(0,0,0,.4);}',
      '.rv-step{display:none;flex-direction:column;gap:16px;}',
      '.rv-step.rv-step--on{display:flex;}',
      '.rv-pane{display:none;flex-direction:column;gap:16px;}',
      '.rv-pane.rv-pane--on{display:flex;}',
      '.rv-h3{font-size:1.2rem;font-weight:700;color:#000;margin:0 0 4px;font-family:inherit;}',
      '.rv-subp{font-size:.875rem;color:rgba(0,0,0,.6);margin:0;line-height:1.5;}',
      '.rv-dz{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;padding:36px 20px;border:2px dashed rgba(0,0,0,.18);border-radius:12px;text-align:center;cursor:pointer;transition:border-color .2s,background .2s;}',
      '.rv-dz.rv-dz--over,.rv-dz:hover{border-color:#000;background:rgba(0,0,0,.03);}',
      '.rv-dz-input{position:absolute;width:1px;height:1px;opacity:0;pointer-events:none;}',
      '.rv-dz-icon{color:rgba(0,0,0,.28);margin-bottom:4px;}',
      '.rv-dz-label{font-size:.875rem;color:rgba(0,0,0,.6);margin:0;}',
      '.rv-dz-btn{padding:8px 20px;font-size:.875rem;font-weight:600;font-family:inherit;background:#000;color:#fff;border:none;border-radius:8px;cursor:pointer;margin-top:2px;transition:opacity .15s;}',
      '.rv-dz-btn:hover{opacity:.82;}',
      '.rv-dz-hint{font-size:.775rem;color:rgba(0,0,0,.35);margin:0;}',
      '.rv-thumb-frame{position:relative;border-radius:10px;overflow:hidden;}',
      '.rv-thumb-img{width:100%;max-height:65vh;object-fit:cover;display:block;border-radius:10px;}',
      '.rv-change-btn{position:absolute;top:10px;left:10px;display:inline-flex;align-items:center;gap:4px;padding:5px 12px;font-size:.78rem;font-weight:600;font-family:inherit;background:rgba(0,0,0,.55);color:#fff;border:none;border-radius:20px;cursor:pointer;backdrop-filter:blur(4px);transition:background .15s;}',
      '.rv-change-btn:hover{background:rgba(0,0,0,.72);}',
      '.rv-gen-btn{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:14px 20px;font-size:.9375rem;font-weight:700;font-family:inherit;background:#000;color:#fff;border:none;border-radius:10px;cursor:pointer;transition:opacity .15s;}',
      '.rv-gen-btn:hover{opacity:.82;}',
      '.rv-loading{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;padding:52px 16px;text-align:center;}',
      '.rv-ring{width:56px;height:56px;color:#000;}',
      '.rv-ring svg{width:100%;height:100%;}',
      '.rv-arc{animation:rv-spin 1.1s linear infinite;transform-origin:50% 50%;}',
      '.rv-load-t{font-size:1rem;font-weight:600;color:#000;margin:0;min-height:1.5em;transition:opacity .3s;}',
      '.rv-load-t.rv-fade{opacity:0;}',
      '.rv-load-s{font-size:.85rem;color:rgba(0,0,0,.45);margin:0;}',
      '.rv-prog{width:100%;max-width:220px;height:3px;background:rgba(0,0,0,.1);border-radius:2px;overflow:hidden;}',
      '.rv-prog-bar{height:100%;background:#000;border-radius:2px;width:0%;transition:width 1s ease;}',
      '.rv-res-frame{position:relative;border-radius:12px;overflow:hidden;}',
      '.rv-res-img{width:100%;max-height:65vh;object-fit:cover;display:block;}',
      '.rv-ai-tag{position:absolute;top:10px;right:10px;padding:3px 10px;font-size:.7rem;font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:#fff;background:rgba(0,0,0,.5);backdrop-filter:blur(4px);border-radius:20px;}',
      '.rv-cta{display:flex;align-items:flex-start;gap:12px;padding:16px;background:rgba(0,0,0,.04);border-radius:10px;}',
      '.rv-cta-icon{display:flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:50%;background:#000;color:#fff;flex-shrink:0;margin-top:2px;}',
      '.rv-cta-h{font-size:1.1rem;font-weight:700;color:#000;margin:0 0 3px;font-family:inherit;}',
      '.rv-cta-p{font-size:.875rem;color:rgba(0,0,0,.6);margin:0;line-height:1.4;}',
      '.rv-atc-btn{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:14px 20px;font-size:.9375rem;font-weight:700;font-family:inherit;background:#000;color:#fff;border:none;border-radius:10px;cursor:pointer;transition:opacity .15s;}',
      '.rv-atc-btn:hover{opacity:.82;}',
      '.rv-retry-link{display:block;width:100%;padding:8px;font-size:.875rem;font-family:inherit;font-weight:500;text-align:center;color:rgba(0,0,0,.45);background:none;border:none;cursor:pointer;transition:color .15s;}',
      '.rv-retry-link:hover{color:#000;}',
      '.rv-err{display:flex;flex-direction:column;align-items:center;gap:14px;padding:52px 16px;text-align:center;}',
      '.rv-err svg{color:rgba(0,0,0,.28);}',
      '.rv-err-msg{font-size:.875rem;color:rgba(0,0,0,.7);margin:0;max-width:320px;line-height:1.55;}',
      '.rv-err-btn{padding:8px 20px;font-size:.875rem;font-weight:600;font-family:inherit;background:transparent;color:#000;border:1.5px solid rgba(0,0,0,.25);border-radius:8px;cursor:pointer;transition:border-color .15s;}',
      '.rv-err-btn:hover{border-color:#000;}',
      '@keyframes rv-fade{from{opacity:0}to{opacity:1}}',
      '@keyframes rv-up{from{transform:translateY(20px) scale(.97);opacity:0}to{transform:none;opacity:1}}',
      '@keyframes rv-spin{to{transform:rotate(360deg)}}',
      '@media(max-width:479px){.rv-card{padding:18px;border-radius:14px;}.rv-h3{font-size:1.05rem;}}',
    ].join('');
    document.head.appendChild(s);
  }

  /* ─── Bootstrap ─────────────────────────────────────────────── */
  var singleton = null;

  function boot() {
    injectCSS();
    document.querySelectorAll('[data-rv-trigger]').forEach(function (btn) {
      if (btn._rv) return;
      btn._rv = true;
      btn.addEventListener('click', function () {
        if (!singleton) singleton = new RVModal();
        singleton.open(btn);
      });
    });
  }

  /* ─── Modal ──────────────────────────────────────────────────── */
  function RVModal() {
    this.triggerBtn      = null;
    this.productImageUrl = '';
    this.roomData        = null;
    this._prodPromise    = null;
    this._msgTimer       = null;
    this._progTimer      = null;

    this.el = document.createElement('div');
    this.el.className = 'rv-overlay';
    this.el.setAttribute('role', 'dialog');
    this.el.setAttribute('aria-modal', 'true');
    this.el.innerHTML = RVModal.TEMPLATE;
    document.body.appendChild(this.el);
    this._listen();
  }

  RVModal.prototype.open = function (btn) {
    this.triggerBtn      = btn;
    this.productImageUrl = btn.dataset.rvProductImage || '';
    var title = btn.dataset.rvProductTitle || '';
    this.el.querySelectorAll('.rv-pname').forEach(function (n) { n.textContent = title; });
    this._resetToUpload();
    this.el.classList.add('rv--open');
    document.body.style.overflow = 'hidden';
    this.el.querySelector('[data-rv-close]').focus();

    /* Preload + resize product image in background */
    var self = this;
    var prodUrl = this.productImageUrl.replace(/width=\d+/, 'width=700');
    this._prodPromise = this._toB64(prodUrl).then(function (p) {
      return self._resize('data:' + p.mime + ';base64,' + p.b64, 700, 0.75)
        .then(function (small) {
          var sp = small.split(',');
          return { b64: sp[1], mime: sp[0].match(/:(.*?);/)[1] };
        });
    });
  };

  RVModal.prototype.close = function () {
    this._stopLoading();
    this.el.classList.remove('rv--open');
    document.body.style.overflow = '';
    if (this.triggerBtn) this.triggerBtn.focus();
  };

  /* ── Steps ──────────────────────────────────────────────────── */
  RVModal.prototype._goTo = function (step) {
    this.el.querySelectorAll('.rv-step').forEach(function (s) {
      s.classList.toggle('rv-step--on', +s.dataset.step === step);
    });
    this.el.querySelectorAll('.rv-dot').forEach(function (d) {
      var i = +d.dataset.dot;
      d.className = 'rv-dot' + (i === step ? ' rv-dot--now' : i < step ? ' rv-dot--done' : '');
    });
  };

  RVModal.prototype._resetToUpload = function () {
    this._clearPhoto();
    this._goTo(1);
  };

  RVModal.prototype._clearPhoto = function () {
    this.roomData = null;
    var fi = this.el.querySelector('[data-rv-file]');
    if (fi) fi.value = '';
    var thumb = this.el.querySelector('[data-rv-thumb]');
    if (thumb) thumb.src = '';
    this.el.querySelector('[data-rv-idle]').classList.add('rv-pane--on');
    this.el.querySelector('[data-rv-preview]').classList.remove('rv-pane--on');
  };

  /* ── File handling ──────────────────────────────────────────── */
  RVModal.prototype._resize = function (dataUrl, maxPx, quality) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        var w = img.naturalWidth, h = img.naturalHeight;
        var ratio = Math.min(maxPx / w, maxPx / h, 1);
        var canvas = document.createElement('canvas');
        canvas.width  = Math.round(w * ratio);
        canvas.height = Math.round(h * ratio);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL('image/jpeg', quality));
      };
      img.src = dataUrl;
    });
  };

  RVModal.prototype._onFile = function (file) {
    if (!file) return;
    if (file.size > 15 * 1024 * 1024) { alert('Bitte wähle ein Bild unter 15 MB.'); return; }
    var self = this;
    var reader = new FileReader();
    reader.onload = function (e) {
      self.el.querySelector('[data-rv-thumb]').src = e.target.result;
      self._resize(e.target.result, 900, 0.72).then(function (small) {
        self.roomData = small;
      });
      self.el.querySelector('[data-rv-idle]').classList.remove('rv-pane--on');
      self.el.querySelector('[data-rv-preview]').classList.add('rv-pane--on');
    };
    reader.readAsDataURL(file);
  };

  /* ── Loading animation ──────────────────────────────────────── */
  RVModal.prototype._startLoading = function () {
    var self     = this;
    var msgEl    = this.el.querySelector('[data-rv-load-msg]');
    var progBar  = this.el.querySelector('.rv-prog-bar');
    var msgIndex = 0;
    var progPct  = 0;

    msgEl.textContent = LOAD_MSGS[0];
    this._msgTimer = setInterval(function () {
      if (msgIndex >= LOAD_MSGS.length - 1) {
        clearInterval(self._msgTimer);
        self._msgTimer = null;
        return;
      }
      msgIndex++;
      msgEl.classList.add('rv-fade');
      setTimeout(function () {
        msgEl.textContent = LOAD_MSGS[msgIndex];
        msgEl.classList.remove('rv-fade');
      }, 300);
    }, 6000);

    /* Fake progress bar — crawls to 90%, never reaches 100% */
    var steps = [12, 10, 8, 7, 6, 5, 4, 3, 2, 2, 2, 2, 2, 1, 1];
    var si = 0;
    this._progTimer = setInterval(function () {
      if (progPct < 90) {
        var inc = si < steps.length ? steps[si++] : 1;
        progPct = Math.min(90, progPct + inc);
        progBar.style.width = progPct + '%';
      }
    }, 1200);
  };

  RVModal.prototype._stopLoading = function () {
    if (this._msgTimer)  { clearInterval(this._msgTimer);  this._msgTimer  = null; }
    if (this._progTimer) { clearInterval(this._progTimer); this._progTimer = null; }
  };

  /* ── Generate ───────────────────────────────────────────────── */
  RVModal.prototype._generate = function () {
    if (!this.roomData) return;

    if (!rlCheck()) {
      this.el.querySelector('[data-rv-errmsg]').textContent =
        'Du hast das tägliche Limit von ' + RL_MAX + ' Visualisierungen erreicht. Bitte versuche es morgen wieder.';
      this._goTo(4);
      return;
    }

    var self = this;
    this._goTo(2);
    this._startLoading();

    var parts    = this.roomData.split(',');
    var roomB64  = parts[1];
    var roomMime = parts[0].match(/:(.*?);/)[1];

    var prodReady = this._prodPromise || Promise.resolve(null).then(function () {
      var url = self.productImageUrl.replace(/width=\d+/, 'width=700');
      return self._toB64(url).then(function (p) {
        return self._resize('data:' + p.mime + ';base64,' + p.b64, 700, 0.75)
          .then(function (small) {
            var sp = small.split(',');
            return { b64: sp[1], mime: sp[0].match(/:(.*?);/)[1] };
          });
      });
    });

    prodReady
      .then(function (p) { return self._apiCall(roomB64, roomMime, p.b64, p.mime); })
      .then(function (b64) {
        self._stopLoading();
        self.el.querySelector('.rv-prog-bar').style.width = '100%';
        self.el.querySelector('[data-rv-result]').src = 'data:image/png;base64,' + b64;
        self._goTo(3);
      })
      .catch(function (err) {
        self._stopLoading();
        console.error('[RoomVisualizer]', err);
        self.el.querySelector('[data-rv-errmsg]').textContent =
          err.message || 'Ein unbekannter Fehler ist aufgetreten. Bitte versuche es erneut.';
        self._goTo(4);
      });
  };

  /* ── Helpers ────────────────────────────────────────────────── */
  RVModal.prototype._toB64 = function (url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('Produktbild konnte nicht geladen werden.');
      return r.blob();
    }).then(function (blob) {
      return new Promise(function (res, rej) {
        var rd = new FileReader();
        rd.onload = function () {
          var p = rd.result.split(',');
          res({ b64: p[1], mime: p[0].match(/:(.*?);/)[1] });
        };
        rd.onerror = rej;
        rd.readAsDataURL(blob);
      });
    });
  };

  RVModal.prototype._apiCall = function (rB64, rMime, pB64, pMime) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        contents: [{ parts: [
          { text: PROMPT },
          { inline_data: { mime_type: rMime, data: rB64 } },
          { inline_data: { mime_type: pMime, data: pB64 } }
        ]}],
        generationConfig: { responseModalities: ['TEXT', 'IMAGE'] }
      })
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw new Error((json.error && json.error.message) || 'API-Fehler: ' + r.status);
        var pts = (json.candidates && json.candidates[0] &&
                   json.candidates[0].content && json.candidates[0].content.parts) || [];
        var img = null;
        for (var i = 0; i < pts.length; i++) {
          if (pts[i].inlineData && /^image\//.test(pts[i].inlineData.mimeType)) { img = pts[i]; break; }
        }
        if (!img) throw new Error('Kein Bild von der KI erhalten. Bitte versuche es erneut.');
        return img.inlineData.data;
      });
    });
  };

  RVModal.prototype._atc = function () {
    var btn = document.querySelector('button[name="add"]:not([disabled])');
    if (btn) { this.close(); btn.click(); }
  };

  /* ── Events ─────────────────────────────────────────────────── */
  RVModal.prototype._listen = function () {
    var self = this, el = this.el;

    el.addEventListener('click', function (e) { if (e.target === el) self.close(); });
    el.querySelector('[data-rv-close]').addEventListener('click', function () { self.close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('rv--open')) self.close();
    });

    var fi = el.querySelector('[data-rv-file]');
    el.querySelector('[data-rv-select]').addEventListener('click', function () { fi.click(); });
    fi.addEventListener('change', function (e) { self._onFile(e.target.files[0]); });

    var dz = el.querySelector('[data-rv-dz]');
    dz.addEventListener('dragover', function (e) { e.preventDefault(); dz.classList.add('rv-dz--over'); });
    dz.addEventListener('dragleave', function (e) {
      if (!dz.contains(e.relatedTarget)) dz.classList.remove('rv-dz--over');
    });
    dz.addEventListener('drop', function (e) {
      e.preventDefault(); dz.classList.remove('rv-dz--over');
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f && /^image\//.test(f.type)) self._onFile(f);
    });

    el.querySelector('[data-rv-change]').addEventListener('click', function () { self._clearPhoto(); });
    el.querySelector('[data-rv-generate]').addEventListener('click', function () { self._generate(); });
    el.querySelector('[data-rv-atc]').addEventListener('click', function () { self._atc(); });
    el.querySelectorAll('[data-rv-retry]').forEach(function (b) {
      b.addEventListener('click', function () { self._resetToUpload(); });
    });
  };

  /* ─── Template ──────────────────────────────────────────────── */
  RVModal.TEMPLATE = [
    '<div class="rv-card">',
      '<div class="rv-bar">',
        '<button class="rv-close" data-rv-close aria-label="Schließen">',
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
        '</button>',
        '<div class="rv-dots">',
          '<span class="rv-dot" data-dot="1"></span>',
          '<span class="rv-dot" data-dot="2"></span>',
          '<span class="rv-dot" data-dot="3"></span>',
        '</div>',
      '</div>',

      '<div class="rv-step" data-step="1">',
        '<div class="rv-pane" data-rv-idle>',
          '<div>',
            '<h3 class="rv-h3">Sieh es in deinem Zimmer</h3>',
            '<p class="rv-subp">Lade ein Foto deines Zimmers hoch – die KI platziert <strong class="rv-pname"></strong> für dich an die Wand.</p>',
          '</div>',
          '<div class="rv-dz" data-rv-dz>',
            '<input type="file" accept="image/jpeg,image/png,image/webp" data-rv-file class="rv-dz-input">',
            '<svg class="rv-dz-icon" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',
            '<p class="rv-dz-label">Foto hier ablegen oder</p>',
            '<button type="button" class="rv-dz-btn" data-rv-select>Datei auswählen</button>',
            '<p class="rv-dz-hint">JPG &middot; PNG &middot; WEBP &middot; max. 15 MB</p>',
          '</div>',
        '</div>',
        '<div class="rv-pane" data-rv-preview>',
          '<div class="rv-thumb-frame">',
            '<img data-rv-thumb src="" alt="Vorschau" class="rv-thumb-img">',
            '<button type="button" class="rv-change-btn" data-rv-change>',
              '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>',
              ' Anderes Foto',
            '</button>',
          '</div>',
          '<button type="button" class="rv-gen-btn" data-rv-generate>',
            'Zimmer visualisieren ',
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>',
          '</button>',
        '</div>',
      '</div>',

      '<div class="rv-step" data-step="2">',
        '<div class="rv-loading">',
          '<div class="rv-ring">',
            '<svg viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="3" opacity=".12"/><circle class="rv-arc" cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-dasharray="84 42"/></svg>',
          '</div>',
          '<p class="rv-load-t" data-rv-load-msg>Zimmer wird analysiert …</p>',
          '<div class="rv-prog"><div class="rv-prog-bar"></div></div>',
          '<p class="rv-load-s">Bitte warte einen Moment</p>',
        '</div>',
      '</div>',

      '<div class="rv-step" data-step="3">',
        '<div class="rv-res-frame"><img data-rv-result src="" alt="KI-Zimmer-Visualisierung" class="rv-res-img"><span class="rv-ai-tag">KI-Vorschau</span></div>',
        '<div class="rv-cta">',
          '<div class="rv-cta-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg></div>',
          '<div><p class="rv-cta-h">Überzeugt?</p><p class="rv-cta-p">Füge <strong class="rv-pname"></strong> jetzt in deinen Warenkorb hinzu.</p></div>',
        '</div>',
        '<button type="button" class="rv-atc-btn" data-rv-atc><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> In den Warenkorb</button>',
        '<button type="button" class="rv-retry-link" data-rv-retry>Anderes Foto wählen</button>',
      '</div>',

      '<div class="rv-step" data-step="4">',
        '<div class="rv-err">',
          '<svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><circle cx="12" cy="16.5" r=".6" fill="currentColor"/></svg>',
          '<p class="rv-err-msg" data-rv-errmsg>Ein Fehler ist aufgetreten.</p>',
          '<button type="button" class="rv-err-btn" data-rv-retry>Erneut versuchen</button>',
        '</div>',
      '</div>',
    '</div>',
  ].join('');

  /* ─── Init ──────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
